export enum PayTypeValue {
    savings = 'savings',
    current = 'current'
}



// WEBPACK FOOTER //
// ./src/app/common/enums/pay-type.enum.ts